import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";
import { theme } from "../constants/theme";
import { HeaderWithButtons } from "../components-molecules";
import { ButtonPrimary, CircularProggressIndicator } from "../components-atoms";
import { buttonHoverAndActive, textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { IUPCImportItemProps, listUpcImports } from "../redux/actions/upc";
import UPCImportItem from "../components-molecules/UPCImportItem";
import UPCImportModal from "./UPCImportModal";
import CssBaseline from "@material-ui/core/CssBaseline";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import UPCExportModal from "./UPCExportModal";

export const UPCImports = (props: any) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [upcImports, setUpcImports] = useState<IUPCImportItemProps[]>();
  const [importUpcModal, setImportUpcModal] = useState<boolean>(false);
  const [exportUpcModal, setExportUpcModal] = useState<boolean>(false);
  const currentDataRef = useRef<IUPCImportItemProps[]>();
  const fetchListInterval = 60; // 1 minute

  useEffect(() => {
    fetchData(true);
  }, []);

  useEffect(() => {
    setInterval(() => {
      fetchData(false);
    }, fetchListInterval * 1000);
  }, [fetchListInterval]);

  const fetchData = (_loading?: boolean) => {
    if (_loading) {
      setLoading(true);
    }
    listUpcImports((res) => {
      // Compare old data with new data
      const oldIds = currentDataRef.current?.map(item => item.ImportId) || [];
      const newIds = res?.map(item => item.ImportId) || [];

      const hasChanges = oldIds.length !== newIds.length ||
        oldIds.some((id, index) => id !== newIds[index]);

      if (hasChanges) {
        setUpcImports(res);
        currentDataRef.current = res;
      }
      setLoading(false);
    },
      (err) => {
        console.log('Err', err);
        setLoading(false);
      })
  }

  const onDone = () => {
    fetchData(true);
    setImportUpcModal(false);
  }

  return (
    <div className={classes.container}>
      <CssBaseline />
      <div className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons>
          <HeaderWithButtons.ButtonArea>
            <div className={classes.mgLeftAuto}>
              <ButtonPrimary
                data-automation="import-upc-button"
                variant="contained"
                color="primary"
                disableElevation
                className={classes.primaryButton}
                style={{
                  paddingLeft: props.loading ? "12px" : "16px",
                }}
                startIcon={<CloudDownloadIcon />}
                onClick={() => {
                  setImportUpcModal(true);
                }}
              >
                Import UPC Template
              </ButtonPrimary>
              <ButtonPrimary
                data-automation="export-upc-button"
                variant="contained"
                color="primary"
                disableElevation
                className={classes.primaryButton}
                style={{
                  paddingLeft: props.loading ? "12px" : "16px",
                }}
                startIcon={<CloudUploadIcon />}
                onClick={() => {
                  setExportUpcModal(true);
                }}
              >
                Export UPC Template
              </ButtonPrimary>
            </div>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        <div className={classes.contentContainer}>
          {loading ? (
            <CircularProggressIndicator />
          ) :
            upcImports?.map((item) =>
              <UPCImportItem
                key={item.ImportId}
                data={item}
              />
            )
          }
        </div>
      </div>
      <UPCImportModal
        isOpen={importUpcModal}
        onClose={() => setImportUpcModal(false)}
        onDone={onDone} />
      <UPCExportModal
        isOpen={exportUpcModal}
        onClose={() => setExportUpcModal(false)} />
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  mgLeftAuto: {
    display: "flex",
    flexDirection: "row",
    paddingRight: 24,
  },
  root: {
    flexGrow: 1,
  },
  tabContainer: {
    backgroundColor: theme.palette.background.paper,
    paddingBottom: "8px",
  },
  primaryButton: {
    marginLeft: 8,
    borderRadius: 8,
    ...buttonHoverAndActive
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    marginRight: "8px",
    ...textButtonHoverAndActive
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  contentContainer: {
    marginTop: 64
  }
});